var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("search-form-choice-list", {
    attrs: {
      label: _vm.label,
      name: _vm.name,
      "option-groups": _vm.optionGroups,
      value: _vm.choiceListValue,
    },
    on: { input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }